<template>
  <div class="custMargin">
     <!-- Information about LTO -->
    <div v-if="showInfoBox" class="info-box marginBottom">
      <div class="flexContainer"> 
        <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon" />
        <ul class="info-text">
          <li v-for="item in infoItems" :key="item">{{ item }}</li>
        </ul>
      </div>
      <div class="text-right">
        <VButton class="vvd-btn-secondary" connotation="cta" appearance="outlined" label="Learn More" @click="learnMore"></VButton>
      </div>
    </div>
    <div v-if="template_subtype !== 'Carousel'" class="domainContainer">
      <p class="title paddingBottom">{{ 'Header (optional)' }}</p>
      <p class="sub-title paddingBottom">{{ template_subtype !== 'LTO' ? `Add a title or choose which type of media you'll use for this header` : `Add a image / video you'll use for this header`}}</p>
      <selectDropDown
        :options="headerFormatOptions"
        :selectedValueProp="selectedFormat || 'None'"
        :isDisabled="isViewOnlyMode"
        placeholder="Select Type"
        @onSelectOption="val => { selectedFormat = val.selectedValue === 'None' ? undefined : val.selectedValue; resetUploadedItems(); }"
      />
    </div>
    <!-- Text -->
    <div v-if="selectedFormat === 'TEXT'" class="domainContainer">
      <p class="sub-title paddingBottom">Header text (Max 60 characters)</p>
      <div class="counter-wrapper">
        <VTextField v-model="localHeaderData.text" @update:modelValue="() => $emit('headerText', localHeaderData.text)" :readonly="isViewOnlyMode" placeholder="Enter header Text" :maxlength="60" aria-label="text" appearance="ghost" class="vivid-input"></VTextField>
        <div class="custom-counter">
            {{ (localHeaderData.text || '').length }}/60
        </div>
      </div>
    </div>
    <!-- Image -->
    <div v-if="selectedFormat === 'IMAGE'" class="marginBottom">
      <TemplateFileUpload type="image" @uploadedFileData="uploadedFileData" :isViewOnlyMode="isViewOnlyMode" />
    </div>
    <!-- Video -->
    <div v-else-if="selectedFormat === 'VIDEO'" class="marginBottom">
      <TemplateFileUpload type="video" @uploadedFileData="uploadedFileData" :isViewOnlyMode="isViewOnlyMode" />
    </div>
    	<!-- Document -->
    <div v-else-if="selectedFormat === 'DOCUMENT'" class="marginBottom">
      <TemplateFileUpload type="document" @uploadedFileData="uploadedFileData" :isViewOnlyMode="isViewOnlyMode" />
    </div>
  </div>  
</template>

<script>
import TemplateFileUpload from "./template-file-upload.vue";
import selectDropDown from '@/components/selectDropDown.vue';

export default {
  emits: ["headerText", "uploadedFiles", "selectedBodyFormat"],
  components: {
    TemplateFileUpload,
    selectDropDown
  },
  props: {
    headerData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    template_subtype: {
      type: String,
      default: 'generic'
    },
    isViewOnlyMode: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      localHeaderData: { ...this.headerData },
    };
  },
  computed: {
    headerFormatOptions() {
      const options = [{ title: 'None', value: 'None' }];
      if (this.template_subtype !== 'LTO') {
        options.push({ title: 'Text', value: 'TEXT' });
      }
      options.push({ title: 'Image', value: 'IMAGE' });
      options.push({ title: 'Video', value: 'VIDEO' });
      if (this.template_subtype !== 'LTO') {
        options.push({ title: 'Document', value: 'DOCUMENT' });
      }
      return options;
    },
    showInfoBox() {
      return ['Carousel', 'LTO', 'Coupon', 'generic', 'Catalog'].includes(this.template_subtype);
    },
    infoItems() {
      if (this.template_subtype === 'LTO') {
        return [
        'Template is visible on mobile app only, not on Web or desktop app',
        'Footer component is not allowed'
        ];
      } else if (this.template_subtype === 'generic') {
        return [
          'Custom body text (1024 Characters max)',
          'Supports up to 10 buttons (Limitations of individual buttons and combination limits apply).'
        ];
      } else if (this.template_subtype === 'Coupon') {
        return [
          'Coupon code templates are currently not supported by the WhatsApp web client',
          'Codes are limited to 15 characters',
          'Button text cannot be customized',
          'Templates are limited to one copy code button'
        ];
      } else if (this.template_subtype === 'Carousel') {
        return [
          'Support up to 10 carousel cards',
          'Mandatory - Cards must have a media header (image or video)',
          'Optional - Text and up to 2 buttons (Quick reply, URL button)',
          'The media header format and button types must be the same across all cards that make up a carousel template.'
        ];
      }  else if (this.template_subtype === 'Catalog') {
        return [
          'Must include product thumbnail header image',
          'Fixed text header and sub header',
          'Custom body text'
        ];
      } 
    return [];
    },
    selectedFormat: {
      get() {
        if (this.localHeaderData && this.localHeaderData.format !== undefined && this.localHeaderData.format !== 'None') {
          return this.localHeaderData.format;
        }
        return 'None';
      },
      set(value) {
        this.$emit('selectedBodyFormat', value);
      }
    }
  },
  watch: {
    headerData: {
      handler(newValue) {
        this.localHeaderData = { ...newValue };
        this.selectedFormat = newValue.format || undefined;
      },
      deep: true,
      immediate: true
    }
  },
  methods:{
    learnMore(){
      switch (this.template_subtype) {
        case 'Carousel':
          window.open('https://developers.facebook.com/docs/whatsapp/business-management-api/message-templates/carousel-templates', '_blank');
          break;
        case 'LTO':
          window.open('https://developers.facebook.com/docs/whatsapp/business-management-api/message-templates/limited-time-offer-templates', '_blank');
          break;
        case 'Coupon':
          window.open('https://developers.facebook.com/docs/whatsapp/business-management-api/message-templates/coupon-templates', '_blank');
          break;
        case 'generic':
          window.open('https://developers.facebook.com/docs/whatsapp/business-management-api/message-templates/components', '_blank');
          break;
        case 'Catalog':
          window.open('https://developers.facebook.com/docs/whatsapp/business-management-api/message-templates/catalog-templates', '_blank');
          break;
      }
    },
    resetUploadedItems() {
			this.localHeaderData.example = [];
      this.$emit('uploadedFiles', this.localHeaderData.example || '');
		},
    uploadedFileData (urlData) {
      this.localHeaderData.example = [urlData[0]];
      this.$emit('uploadedFiles', this.localHeaderData.example || '');
    }
  }
}
</script>

<style scoped>
.info-box {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  background: var(--purple-opac);
  padding: 15px 10px;
  border-radius: 5px;
}
.info-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--black);
  margin: 0;
}
.marginBottom {
	margin-bottom: 20px;
}
.domainContainer {
  padding-bottom: 10px;
	width: 100%;
}
.sub-title {
  font-size: 14px;
  color: var(--gray-04);
  font-weight: 400;
  line-height: 16px;
}
.flexContainer {
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: flex-start;
}
.paddingBottom {
  padding-bottom: 10px;
}
ul {
  padding-left: 10px;
}
.title {
  font-size: 14px;
  color: var(--black);
  font-weight: 400;
  line-height: 16px;
}
.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}
.custMargin {
	margin-bottom: 10px;
}
@media only screen and (max-width: 760px) {
  .info-box {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
